//登录
export function login(data) {
  return axios({
    url: '/login',
    method: 'post',
    data
  })
}

//退出
export function logout() {
  return axios({
    url: '/logout',
    method: 'post'
  })
}

//得到用户信息
export function getUserInfo() {
  return axios({
    url: '/userInfo',
    method: 'post'
  })
}

//修改用户信息
export function updateUserInfo(data) {
  return axios({
    url: '/updateUserInfo',
    method: 'post',
    data
  })
}

//修改登录密码
export function updatePassword(data) {
  return axios({
    url: '/updatePassword',
    method: 'post',
    data
  })
}

//用户设置状态
export function getSetting() {
  return axios({
    url: '/user/getSetting',
    method: 'post'
  })
}

//修改用户设置
export function updateSetting(data) {
  return axios({
    url: '/user/setSetting',
    method: 'post',
    data
  })
}

//统计数据
export function statisticsScenery(data) {
  return axios({
    url: '/statistics/scenery',
    method: 'post',
    data
  })
}